module.exports = "https://static.wmbcdn.com/uniweb/images/556f510871c81dfa190793ee592da536.woff";